import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { errorLogsAPI } from "@/lib/api";

// Global error handler for uncaught JavaScript errors
window.onerror = function(message, source, lineno, colno, error) {
  try {
    errorLogsAPI.report({
      error_message: message || 'Unknown JS error',
      page: window.location.pathname,
      action: 'JavaScript Error',
      user_description: `Source: ${source}:${lineno}:${colno}\nStack: ${error?.stack || 'N/A'}`,
    }).catch(() => {});
  } catch (e) {
    console.error('Failed to report JS error:', e);
  }
  return false;
};

// Global handler for unhandled promise rejections
window.onunhandledrejection = function(event) {
  try {
    errorLogsAPI.report({
      error_message: event.reason?.message || String(event.reason) || 'Unhandled Promise Rejection',
      page: window.location.pathname,
      action: 'Promise Rejection',
      user_description: `Reason: ${event.reason?.stack || String(event.reason)}`,
    }).catch(() => {});
  } catch (e) {
    console.error('Failed to report promise rejection:', e);
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
